import { render, staticRenderFns } from "./TaskAll.vue?vue&type=template&id=c82748f2&scoped=true"
import script from "./TaskAll.vue?vue&type=script&lang=js"
export * from "./TaskAll.vue?vue&type=script&lang=js"
import style0 from "./TaskAll.vue?vue&type=style&index=0&id=c82748f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82748f2",
  null
  
)

export default component.exports